import React from "react";
import "./ProcessResultModal.scss";
import ScriptBox from "../../../ScriptBox/ScriptBox";
import EditIcon from "../../../VectorIcons/EditIcon";
import EditRelevanceModal from "../../../../views/ProjectSheet/EditSheetRelevance/RelevanceSection/EditRelevanceModal";

const mapCategoryToKey = (category) => {
  switch (category) {
    case "PRINCIPAL":
      return "primaries";
    case "SECUNDARIA":
      return "secundaries";
    case "TERCIARIA":
      return "tertiaries";
    default:
      return null;
  }
};

const DESCRIPTION_BY_KEY = {
  primaries: "Central",
  secundaries: "Secondary",
  tertiaries: "Tertiary",
};

const ORIGIN_BY_TYPE = {
  plot: 3,
  thematic: 6,
  universe: 9,
};

const FIELD_BY_TYPE = {
  plot: "Trama",
  thematic: "Temática",
  universe: "Universo",
};

const buildEditRelevanceData = (items, type) => {
  const normalizedType = type?.toLowerCase();
  const result = {
    [normalizedType]: {
      primaries: [],
      secundaries: [],
      tertiaries: [],
    },
  };

  items.forEach(({ data }) => {
    const key = mapCategoryToKey(data.category);
    if (!key) return;

    result[normalizedType][key].push({
      id: data.id,
      origin: ORIGIN_BY_TYPE[normalizedType],
      name: data.name,
      description: DESCRIPTION_BY_KEY[key],
      descriptionContext: data.justification,
      field: FIELD_BY_TYPE[normalizedType],
      generatedByAI: true,
    });
  });

  return result;
};

export function ProcessResultModal({
  open,
  data,
  contentId,
  onDiscard,
  onClose,
  setCloseModal,
  workflowNoContent,
}) {

  const handleCloseModal = () => {
    if (typeof onClose === "function") {
      onClose();
    }
  };

  const normalizedData =
    !workflowNoContent && data?.items && data?.type
      ? buildEditRelevanceData(data.items, data.type)
      : null;

  const normalizedType =
    !workflowNoContent && data?.type
      ? data.type.toLowerCase()
      : undefined;

  return (
    <ScriptBox
      open={open}
      title={"Editar Trama"}
      icon={<EditIcon color="#FFF" />}
      removePadding={true}
      marginBottom={true}
      size="large"
      clear={handleCloseModal}
    >
      <EditRelevanceModal
        data={normalizedData}
        type={normalizedType}
        id={contentId}
        discardText="Descartar"
        onDiscard={onDiscard}
        isProcessingByAI
        setCloseModal={setCloseModal}
        workflowNoContent={workflowNoContent}
      />
    </ScriptBox>
  )
}